import {DialogPosition} from "@angular/material/dialog";

export interface MenuItem {
  name: string;
  route?: string;
  iconType?: string;
  icon: string;
  permission?: string[];
  userType?: string[];
  url?: string;
  uid?: string;
  active?: boolean;
  children?: MenuItem[];
}

export interface Menu {
  moduleName: string;
  moduleIcon?: string;
  menuItems: MenuItem[];
}

// export const HasMenu:boolean = false;


export interface SvgIcon {
  name: string;
  tag: string;
}

export interface ResponseCode {
  code: number;
  description: string;
}

export interface PageableParam {
  first?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  searchFields?: SearchFieldsDtoInput[];
  isSearch?: boolean;
}

export interface SearchFieldsDtoInput {
  fieldName?: string;
  fieldValue?: string;
  fieldValues?: string[];
  searchType?: SearchOperationType;
}

export enum SearchOperationType {
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  In = 'In',
  LessThan = 'LessThan',
  Like = 'Like',
  NotEquals = 'NotEquals',
}


export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}


export enum ServiceTargetGroupEnum {
  Children = 'Children',
  Special_Needs = 'Special_Needs',
  Elderly = 'Elderly',
  Women = 'Women',
  Youth = 'Youth'
}


export enum AuthTypeEnum {
  API_KEY_AS_Bearer = 'API_KEY_AS_Bearer',
  CLIENTID_SECRET_AS_Basic = 'CLIENTID_SECRET_AS_Basic',
  JWT_AS_Token = 'JWT_AS_Token'
}

export enum FieldInputTypesEnum {
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  DROPDOWN = 'DROPDOWN',
  TEXTFIELD = 'TEXTFIELD',
  TEXTAREA = 'TEXTAREA',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  FILE = 'FILE',
  DATETIME = 'DATETIME',
  ATTACHMENT = 'ATTACHMENT'
}


export enum SystemIntegrationEnum {
  P2P = 'P2P',
  JAMII = 'JAMII',
  GOVESB = 'GOVESB'
}

export enum ConfirmationEnum {
  NO = 'NO',
  YES = 'YES',
}

export enum CollaborationMeansEnum {
  MANUALLY = 'MANUALLY',
  SYSTEM = 'SYSTEM'
}

export enum FieldInputSizeEnum {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

export enum SubmitResubmitEnum {
  SUBMIT = 'SUBMIT',
  RESUBMIT = 'RESUBMIT'
}

export enum ApprovalActionEnum {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT'
}

export enum NoYesNotSure {
  NO = 'NO',
  YES = 'YES',
}

export enum ServiceClusterEnum {
  G2C = 'G2C',
  G2G = 'G2G',
  G2B = 'G2B',
  G2E = 'G2E',
  G2F = 'G2F'
}

export enum ServiceClusterEnumTranslate {
  G2C = 'Government to Citizen',
  G2G = 'Government to Government',
  G2B = 'Government to Business',
  G2E = 'Government to Employee',
  G2F = 'Government to Foreigner'
}

// export enum InstitutionTypeEnum {
//   MINISTRY
//   INDEPENDENT_SECTOR
//   DISTRICT_COUNCIL
//   REGIONAL_SECRETARIAT
//   MDA
//   MUNICIPAL
// }

export enum ServiceChannelEnum {
  ONLINE = 'ONLINE',
  WALK_IN = 'WALK_IN',
  PHYSICAL_DELIVERY = 'PHYSICAL_DELIVERY'
}

export enum AutomationPartEnum {
  Internal = 'Internal',
  External = 'External',
  Both = 'Both'
}

export enum ProvisionMeansEnum {
  Web = 'Web',
  MobileApp = 'MobileApp',
  USSD = 'USSD',
  SMS = 'SMS'
}

export enum ExistenceEnum {
  LAW = 'LAW',
  GUIDLINES = 'GUIDLINES',
  REGULATION = 'REGULATION'
}

export enum BillingSchemeEnum {
  NO_COST = 'NO_COST',
  DIRECT_COST = 'DIRECT_COST',
  PERCENTAGE_BASED = 'PERCENTAGE_BASED',
  CATALOGY_BASED = 'CATALOGY_BASED',
  FORMULAR_BASED = 'FORMULAR_BASED'
}


export const initializedPageableParameter = {
  first: 0,
  size: 10,
  sortBy: 'id',
  sortDirection: 'DESC',
};

export interface AttachmentDtoInput {
  id?: number;
  createdAt?: string;
  fullPath?: string;
  dataBinary?: string | ArrayBuffer;
  sourceName?: string;
  filePath?: string;
  attachmentTitle?: string;
  attachmentType?: string;
  data?: string | ArrayBuffer;
  sourceUid?: string;
}

export interface OpenDialog {
  data?: any;
  component: any;
  width?: string;
  panelClass?: string[];
  position?: DialogPosition;
  height?: string;
}

export const tzPhone = '(255|0)[^0123459]([0-9]{8})';

export const generalPhoneNumber = '[0-9]{6,}';


export function truncateString(str: string | undefined, length: number): string {
  if (!str) return ''; // Return empty string if no description is provided
  return str.length > length ? str.slice(0, length) + '...' : str;
}
